import { render, staticRenderFns } from "./ClientStatus.vue?vue&type=template&id=75df20ce&scoped=true&"
import script from "./ClientStatus.vue?vue&type=script&lang=js&"
export * from "./ClientStatus.vue?vue&type=script&lang=js&"
import style0 from "./ClientStatus.vue?vue&type=style&index=0&id=75df20ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75df20ce",
  null
  
)

export default component.exports